import { Component, EventEmitter, Input, Output } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  @Input() identifier: string
  @Input() data: any
  @Output() anchorCustom = new EventEmitter()
  @Input() medias = [{ style: 'large', media: '(min-width:421px)' }]

  constructor(public localDeviceDetector: LocalDeviceDetectorService) {
  }

}
